import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../../lib/api.ts';
import { SiteLayout } from '../../components/SiteLayout.tsx';

export function LoginPage() {
  const nav = useNavigate();
  // ?til=/admin/login sender tilbake etter innlogging — bare stier på egen side.
  const [params] = useSearchParams();
  const til = params.get('til');
  const maal = til && til.startsWith('/') && !til.startsWith('//') ? til : '/min';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    try {
      await api.kontoLogin(email, password);
      nav(maal, { replace: true });
    } catch (error) {
      setErr((error as ApiError).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <SiteLayout>
      <main className="flex justify-center px-4 py-12 sm:py-16">
        <form
          onSubmit={submit}
          className="w-full max-w-sm bg-slate-900/60 border border-slate-800 rounded-2xl p-6"
        >
          <h1 className="text-xl font-bold text-center mb-5">Logg inn</h1>
          {err && (
            <div className="mb-4 text-red-300 bg-red-900/30 border border-red-800 rounded-lg p-3 text-sm">
              {err}
            </div>
          )}
          <label className="block text-xs text-slate-400 mb-1">E-post</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
            className="w-full mb-3 px-3 py-2 bg-slate-950 border border-slate-700 rounded-lg"
          />
          <label className="block text-xs text-slate-400 mb-1">Passord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            className="w-full mb-5 px-3 py-2 bg-slate-950 border border-slate-700 rounded-lg"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-sky-600 hover:bg-sky-500 active:bg-sky-700 py-3 rounded-lg font-semibold disabled:opacity-60"
          >
            {loading ? 'Logger inn…' : 'Logg inn'}
          </button>
          <div className="mt-5 flex items-center justify-between text-sm">
            <Link to="/konto/ny" className="text-sky-400 hover:text-sky-300">
              Ny bruker?
            </Link>
            <Link to="/konto/glemt" className="text-slate-400 hover:text-slate-200">
              Glemt passord?
            </Link>
          </div>
        </form>
      </main>
    </SiteLayout>
  );
}
